<div class="row">
    <div class="col-6">
        <h3 class="ml-4 mt-3 mb-4">
            Task Manager
        </h3>
    </div>

    <div class="col-6">
        <button mat-button class="btnBack mr-4 absolute_back_button float-right mt-2 mb-2"(click)="resetTabs()"
        (click)="goBack()">Back
      </button>
    </div>
</div>
<div class="col-12 d-flex p-0">
    
        <div class="col-9">
            <mat-card class="w-100">
                        <div class="col-12 p-0 position-relative">
                            <h3>{{taskDetails.task_name}}</h3>
                            <p class="mt-4">{{taskDescription.message}}</p>
                            <div *ngIf="isEditingDesc" class="title-edit mb-4">
                            <form [formGroup]="inputDesc" (ngSubmit)="saveTaskDesc()">
                                <div class="chatTextinput" style="width: 90%;">
                        
                                    <textarea placeholder="Name" matInput class="pb-2 chatInputArea mt-1" formControlName="discription" rows="3"
                                        matInput style="width: 90%;"></textarea>
                                    <div class="d-flex spacebtw">
                                        <div class="d-flex width-file">
                                            <div class="commentsAttach commentAttachPos"
                                                *ngFor='let item of AttachFiles; let j = index'>
                                                <p class="long_text_container">{{item.name}}</p>
                                                <div (click)='removeAttach(j)' class="miniClose">x</div>
                                            </div>
                                        </div>
                                        <div class="attachCover">
                                            <img src="assets/images/boldclip.png" class="pointer" alt="">
                                            <input #attachInput type="file" (change)='addFileComment($event)' multiple>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" class="save-btn float-right mb-4 ml-3" style="margin-top: -85px;">
                                    <mat-icon>check</mat-icon>
                                  </button>
                                  <button type="button" class="cancel-btn float-right mb-4" (click)="cancelEditingDesc()" style="margin-top: -85px;margin-right: 57px;">
                                    <mat-icon>close</mat-icon>
                                  </button>
                              <!-- <textarea class="form-control" formControlName="discription" rows="4"> </textarea>
                              <button type="submit" class="save-btn float-right mb-4 ml-3">
                                <mat-icon>check</mat-icon>
                              </button>
                              <button type="button" class="cancel-btn float-right mb-4" (click)="cancelEditingDesc()">
                                <mat-icon>close</mat-icon>
                              </button> -->
                             
                            </form>
                          </div>

                        <div class="d-flex flex-con" *ngIf='taskDescription["tm_message_attachments"]'>
                            <div class="ml-1 mb-1 pointer" *ngFor="let element of taskDescription['tm_message_attachments']; let i = index">
                            <div class="downloadContainer d-flex" (click)='downLoad(element)'>
                                <div class="text-center attachClip">
                                <img *ngIf="element.av_overall_infected=='N'" src="assets/images/boldclip.png" class="pointer" alt="">
                                <img *ngIf="element.av_overall_infected=='Y'" class="virus-icon" title="Potential malware detected" src="assets/images/file-virus.png">
                                </div>
                                <div class="ChatAttachName" title="{{element.attachment_name}}">
                                <p class="attach-p">{{element.attachment_name}}</p>
                                </div>
                            </div>
                            </div>
                        </div>

                        <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="changeTab($event)">
                            <mat-tab label="Comments">
                                <!-- [ngClass]="messages.length > 0 ? 'scrollCommentSection' : 'scrollCommentSection1'" -->
                                <div class="scrollCommentSection" id="scrollCommentSection">
                                    <div class="chatHistory" id="chatHistory">
                                    <div *ngFor='let item of messages, let i = index'>
                                        <div class="date-container mb-2 mt-2" *ngIf="i==0 || getDate(item.created) != getDate(messages[i-1].created)"><div class="date-gray">{{item.created | date : "MMM dd, yyyy"}}</div></div>
                                        <div class="chat_flex pastChat mb-2">
                                        <div class="propic_container">
                                            <div class='dpCnr _comment' [ngStyle]="{'background-image':'url(' + profile_images[item.createdby] +')' }"></div>
                                        </div>
                                        <div class="chatDetails">
                                            <div class="pastChatContainer ">
                                            <div class="name" title="{{item.created | date : 'MMM dd, yyyy, hh:mm a'}}"> {{item.um_user_name}}
                                                <span *ngIf="item.um_user_is_stdc_user === 'Y'"> (Admin)</span>
                                                <span class="time-gray">{{item.created | date : "hh:mm a"}}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <div class="mr-1"><img src="assets/images/comment.svg" alt=""> </div>
                                                <div class="toAddress">{{item.message_creating_bp_business_name}} </div>
                                            </div>
                                            </div>
                                            <div class="w-100 chatMessge">
                                            <pre *ngIf="item.read_by_user_name && item.read_at_time" title="{{item.read_by_user_name}} read the message on {{item.read_at_time | date : 'MMM dd, yyyy, hh:mm:ss a'}}">{{item.message}}</pre>
                                            <pre *ngIf="!item.read_by_user_name || !item.read_at_time">{{item.message}}</pre>
                                            </div>
                                            <div class="d-flex flex-con" *ngIf='item["tm_message_attachments"]'>
                                            <div class="ml-1 mb-1 pointer" *ngFor="let element of item['tm_message_attachments']; let i = index" (click)='downLoad(element)'>
                                                <div class="downloadContainer d-flex">
                                                <div class="text-center attachClip">
                                                    <img *ngIf="element.av_overall_infected=='N'" src="assets/images/boldclip.png" class="pointer" alt="">
                                                    <img *ngIf="element.av_overall_infected=='Y'" class="virus-icon" title="Potential malware detected" src="assets/images/file-virus.png">
                                                </div>
                                                <div class="ChatAttachName" title="{{element.attachment_name}}">
                                                    <p class="attach-p">{{element.attachment_name}}</p>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                    
                                        </div>
                                        </div>
                                    </div>
                                    <p class="no-re mt-2" *ngIf="messages.length==0">No record found</p>
                                    </div>
                                </div>
                    
                                <div class="absolute_text_input">
                                    <div class="chatTextinput pb-30">
                                    <mat-label *ngIf='aboutBusiness!=="All"' class="titleColor">Message {{aboutBusiness}} about {{selected_business}}</mat-label>
                                    <textarea matInput class="pb-2 chatInputArea mt-1" [readonly]="addButton" [(ngModel)]='newMessage' rows="2" matInput></textarea>
                                    <div class="d-flex spacebtw my-3">
                                        <div class="d-flex width-file">
                                        <div class="commentsAttach commentAttachPos" *ngFor='let item of AttachFiles; let j = index'>
                                            <p class="long_text_container">{{item.name}}</p>
                                            <div (click)='removeAttach(j)' class="miniClose">x</div>
                                        </div>
                                        </div>
                                        <!-- <div class="attach mx-2">
                                        <img   matTooltipClass="matToolTipCmmnt" class="txttooltip"
                                        [title]="tooltip" src="/assets/images/i.svg">
                                        </div> -->
                                        <div class="attachCover" >
                                        <img src="assets/images/boldclip.png" class="pointer" alt="">
                                        <input #attachInput type="file" (change)='addFileComment($event)' multiple>
                                        </div>
                                        <!-- <button mat-raised-button color="primaryCus" [disabled] ="newMessage==''" (click)="addComment('N')" class="text-center send-btn"></button> -->
                                        <button mat-raised-button color="primaryCus" (click)="addComment('N')" class="text-center send-btn"></button>
                                    </div>
                                    </div>
                                    <div class="col-12 p-0 mt-2">
                                    <div>
                                        <span class="doc_add_validation">{{supporetsFiles}}</span>
                                        <span class="doc_add_validation">{{supportMaxFileSize}}</span>
                                    </div>
                                    </div>
                                </div>
                        
                            </mat-tab>
                        </mat-tab-group>
                    </div>
            </mat-card>
        </div>
        
        <div class="col-3">
          <mat-card class="h-100">
            <div class="comply row">
                    <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 ml-3">
                        <div class="popupSubTitle_rules">
                          <span>
                            Status
                          </span>
                        </div>
                        <div class="time">
                          <span>
                            {{taskDetails.status_name}}
                          </span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 ml-3">
                        <div class="popupSubTitle_rules">
                          <span>
                            Assignee
                          </span>
                        </div>
                        <div class="time">
                          <span>
                            {{taskDetails.assign_um_user_fullname}}
                          </span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 ml-3">
                        <div class="popupSubTitle_rules">
                          <span>
                            Due Date
                          </span>
                        </div>
                        <div class="time">
                          <span>
                            {{taskDetails.due_date | date:  'MMM dd, yyyy'}}
                          </span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 ml-3">
                        <div class="popupSubTitle_rules">
                          <span>
                            Assignee Business
                          </span>
                        </div>
                        <div class="time">
                          <span>
                            {{taskDetails.assign_bp_busines_name}}
                          </span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 ml-3">
                        <div class="popupSubTitle_rules">
                          <span>
                           Task ID
                          </span>
                        </div>
                        <div class="time">
                          <span>
                            {{taskDetails.task_id}}
                          </span>
                        </div>
                    </div>
            </div>
          </mat-card>
        </div>
</div>
